import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { Card, IconButton, Tooltip } from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiSelect from "components/SuiSelect";
import SuiTypography from "components/SuiTypography";
import ContactAvatar from "components/UpStyled/ContactAvatar";
import Prompt from "components/UpStyled/Prompt";
import CounterContext from "context/counter";
import { nanoid } from "nanoid";
import { useContext, useEffect, useState, useImperativeHandle, forwardRef } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import api from "services/api";

const smartdate = require("smartdate");
smartdate.init();

const NotificationPanel = forwardRef(
  ({ setRightDrawer, height = null, width = "500px", sx = {} }, ref) => {
    const msgcounter = useContext(CounterContext);
    const [notifications, setNotifications] = useState([]);
    const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
    const [selectedType, setSelectedType] = useState({ value: "all", label: "All types" });

    useImperativeHandle(
      ref,
      () => ({
        notifications,
        setNotifications,
        refresh,
      }),
      [notifications]
    );

    const refresh = () => {
      try {
        api.notifications.list().then(({ data }) => {
          setNotifications(data.notifications);
          return data;
        });
      } catch (err) {
        toast.error(`notifications list!`);
        console.log(err);
      }
      msgcounter.getNewMessageCount();
    };

    useEffect(() => {
      refresh();
    }, []);

    const update = (payload) => {
      try {
        api.notifications.update(payload).then(({ data }) => {
          refresh();
          return data;
        });
      } catch (err) {
        toast.error(`notifications list!`);
        console.log(err);
      }
    };

    var selectednotifications = notifications.filter(
      (n) => selectedType.value == "all" || n.type === selectedType.value
    );
    const renderProfiles = selectednotifications.map((notification) => (
      <SuiBox
        component={notification.target != "#" ? Link : "div"}
        to={notification.target}
        target="_blank"
        style={{ color: "inherit", cursor: "pointer" }}
        onClick={(e) => {
          update({ delete: [notification.id] });
        }}
      >
        <SuiBox
          key={nanoid()}
          component="li"
          display="flex"
          alignItems="center"
          py={1}
          sx={{ cursor: "pointer" }}
        >
          <SuiBox mr={0.5}>
            <ContactAvatar contact={notification} size="xs" />
          </SuiBox>
          <SuiBox className="w-full ml-0.5">
            <SuiBox className="flex justify-between items-center">
              <SuiBox className="flex items-center">
                <SuiTypography variant="button" fontWeight="medium">
                  {notification.type +
                    (["Admin Notice", "event", "reminder"].includes(notification.type)
                      ? ""
                      : " from " + notification.username)}
                </SuiTypography>
              </SuiBox>
              <SuiBox className="flex items-center">
                <SuiTypography variant="caption">
                  {smartdate.format(new Date(notification.timestamp))}
                </SuiTypography>
                <Tooltip title="Clear notification" placement="top">
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      update({ delete: [notification.id] });
                    }}
                    sx={{ p: 0, m: 0, width: "26.25px", height: "26.25px" }}
                    className="hover:bg-gray-300"
                  >
                    <DeleteIcon sx={{ p: 0, m: 0, width: "26.25px", height: "26.25px" }} />
                  </IconButton>
                </Tooltip>
              </SuiBox>
            </SuiBox>
            <div className="flex justify-between">
              <SuiTypography
                variant="caption"
                textTransform="none"
                sx={{
                  width: "100%",
                  minHeight: "28px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {notification.descr}
              </SuiTypography>
            </div>
          </SuiBox>
        </SuiBox>
      </SuiBox>
    ));

    //console.log('contactlist', contactlist)
    return (
      <Card sx={{ height: height ?? "90vh", maxHeight: height ?? "90vh", width: width, ...sx }}>
        <Prompt
          heading="Clear all read notifications confirmation"
          text={`Are you sure you want to clear all read notifications?`}
          visible={deleteDialogVisible}
          okText="Clear"
          okColor="dark"
          handleOk={() => {
            var idlist = selectednotifications.map((n) => n.id);
            if (idlist.length > 0) update({ delete: idlist });
            setDeleteDialogVisible(false);
          }}
          handleClose={() => setDeleteDialogVisible(false)}
        />
        <SuiBox pt={1} px={2}>
          <SuiTypography variant="h6" fontWeight="medium" textTransform="capitalize" sx={{ px: 1 }}>
            {"Notifications"}
          </SuiTypography>
          {setRightDrawer && (
            <IconButton
              aria-label="close"
              onClick={() => {
                setRightDrawer(0);
              }}
              sx={{
                position: "absolute",
                right: 0,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </SuiBox>
        {setRightDrawer && (
          <SuiBox pt={1} px={1} className="flex justify-between items-center">
            <SuiSelect
              size="medium"
              options={[
                { value: "all", label: "All types" },
                { value: "Admin Notice", label: "Admin Notice" },
                { value: "Comments", label: "Comments" },
                { value: "Resource shared", label: "Resource shared" },
                { value: "Tech Pack", label: "Tech Pack" },
              ]}
              onChange={(option) => setSelectedType(option)}
              value={selectedType}
            />
            <SuiButton
              disabled={selectednotifications.length === 0}
              sx={{ m: 0, p: 0, textTransform: "none" }}
              color="dark"
              variant="text"
              onClick={(e) => {
                setDeleteDialogVisible(true);
              }}
            >
              Clear all
            </SuiButton>
          </SuiBox>
        )}
        <SuiBox p={1} sx={{ overflowY: "auto" }}>
          <SuiBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
            {renderProfiles}
          </SuiBox>
        </SuiBox>
      </Card>
    );
  }
);

export default NotificationPanel;
